import { ChevronDown, LayoutDashboard, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { NAV } from "@/constants/testIds";

export function UserMenu({ user, onNavigate, onLogout }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" data-testid={NAV.userMenu} className="text-zinc-800 hover:text-[#1E3A6E] hover:bg-zinc-100 gap-1 rounded-none">
          {user.name?.split(" ")[0] || "Account"} <ChevronDown className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-white border-zinc-200 text-zinc-950 rounded-sm">
        <DropdownMenuItem onClick={() => onNavigate("/dashboard")} data-testid={NAV.dashboard} className="cursor-pointer focus:bg-zinc-100">
          <LayoutDashboard className="h-4 w-4 mr-2" /> Dashboard
        </DropdownMenuItem>
        {user.role === "admin" && (
          <>
            <DropdownMenuItem onClick={() => onNavigate("/admin/scenarios")} className="cursor-pointer focus:bg-zinc-100">
              Admin: Add Scenario
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onNavigate("/admin/incidents")} className="cursor-pointer focus:bg-zinc-100">
              Admin: Incidents
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onNavigate("/admin/subscribers")} className="cursor-pointer focus:bg-zinc-100">
              Admin: Email List
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onNavigate("/admin/volunteers")} data-testid="nav-admin-volunteers-link" className="cursor-pointer focus:bg-zinc-100">
              Admin: Volunteers
            </DropdownMenuItem>
          </>
        )}
        <DropdownMenuSeparator className="bg-zinc-200" />
        <DropdownMenuItem onClick={onLogout} data-testid="logout-button" className="cursor-pointer focus:bg-zinc-100 text-red-600">
          <LogOut className="h-4 w-4 mr-2" /> Log Out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
